'use client'

import { initPostHog } from '@/lib/posthog'
import { PostHogProvider as PHProvider } from 'posthog-js/react'
import type { ReactNode } from 'react'

// Client singleton setup
const posthog = initPostHog()

export function PostHogProvider({ children }: { children: ReactNode }) {
  return <PHProvider client={posthog}>{children}</PHProvider>
}
